export function NumberField({
  label,
  value,
  suffix,
  step = "1",
  onChange,
}: {
  label: string;
  value: number;
  suffix?: string;
  step?: string;
  onChange: (value: number) => void;
}) {
  return (
    <label>
      <span className="label">{label}</span>
      <span className="flex items-center rounded-xl border border-stone-200 bg-white px-3 focus-within:border-lumen-400 dark:border-white/10 dark:bg-white/3">
        <input
          className="min-w-0 flex-1 bg-transparent py-2.5 text-sm outline-none"
          type="number"
          min="0"
          step={step}
          value={value}
          onChange={(event) => onChange(Number(event.target.value))}
        />
        {suffix && <span className="text-xs text-stone-500">{suffix}</span>}
      </span>
    </label>
  );
}
